/**
 * Hero Text Animation
 * Fades in hero text with colored words appearing first, then rest of text
 * Triggers only on page load (if hero section is visible)
 */

(function() {
  'use strict';

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  if (prefersReducedMotion) {
    return; // Exit if user prefers reduced motion
  }

  function initHeroTextAnimation() {
    const heroSections = document.querySelectorAll('.hero');
    
    heroSections.forEach(hero => {
      // Target text blocks more specifically - look for text-block class or direct children
      const textBlocks = hero.querySelectorAll('.hero__content-wrapper .text-block, .hero__content-wrapper > *');
      
      textBlocks.forEach(block => {
        // Skip if already animated or if it's a button
        if (block.classList.contains('hero-text-animate') || block.classList.contains('button') || block.tagName === 'BUTTON') {
          return;
        }
        
        // Only animate text elements (p, h1, h2, h3, div with text-block class)
        const isTextElement = block.tagName === 'P' || 
                             block.tagName === 'H1' || 
                             block.tagName === 'H2' || 
                             block.tagName === 'H3' || 
                             block.tagName === 'H4' || 
                             block.tagName === 'H5' || 
                             block.tagName === 'H6' ||
                             block.classList.contains('text-block') ||
                             block.querySelector('p, h1, h2, h3, h4, h5, h6');
        
        if (isTextElement) {
          // Wrap text content (excluding strong tags) in spans for separate animation
          const walker = document.createTreeWalker(
            block,
            NodeFilter.SHOW_TEXT,
            null,
            false
          );
          
          const textNodes = [];
          let node;
          while (node = walker.nextNode()) {
            // Skip if parent is a strong tag
            if (node.parentElement && node.parentElement.tagName === 'STRONG') {
              continue;
            }
            // Skip if it's only whitespace
            if (node.textContent.trim() === '') {
              continue;
            }
            textNodes.push(node);
          }
          
          // Wrap each text node in a span
          textNodes.forEach(textNode => {
            const span = document.createElement('span');
            span.className = 'hero-text-content';
            textNode.parentNode.insertBefore(span, textNode);
            span.appendChild(textNode);
          });
          
          // Add data attributes to strong tags for sequential animation
          const strongTags = block.querySelectorAll('strong');
          strongTags.forEach((strong, index) => {
            const text = strong.textContent.trim().toLowerCase();
            if (text === 'mindset') {
              strong.setAttribute('data-word-order', '1'); // First word
            } else if (text === 'inspired') {
              strong.setAttribute('data-word-order', '2'); // Second word
            } else {
              strong.setAttribute('data-word-order', String(index + 1));
            }
          });
          
          // Add animation class
          block.classList.add('hero-text-animate');
          
          // Check if already in view on page load
          const rect = block.getBoundingClientRect();
          const isInView = rect.top < window.innerHeight && rect.bottom > 0;
          
          if (isInView) {
            // Trigger animation immediately if in view on load
            setTimeout(() => {
              block.classList.add('animate-in');
            }, 100);
          }
        }
      });
    });
    
    // Also animate buttons in hero sections
    heroSections.forEach(hero => {
      // Match buttons by class prefix (button-primary, button-secondary) or by being an <a> tag with button classes
      const buttons = hero.querySelectorAll('.hero__content-wrapper a[class*="button-"], .hero__content-wrapper a.button-primary--H9gpTf, .hero__content-wrapper a.button-secondary--H9gpTf');
      buttons.forEach(button => {
        if (!button.classList.contains('hero-text-animate')) {
          button.classList.add('hero-text-animate');
          button.classList.add('hero-button-animate');
          
          const rect = button.getBoundingClientRect();
          const isInView = rect.top < window.innerHeight && rect.bottom > 0;
          
          if (isInView) {
            setTimeout(() => {
              button.classList.add('animate-in');
            }, 100);
          }
        }
      });
    });

    // Animation only triggers on page load, not on scroll
    // All elements that are in view on page load will animate automatically
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroTextAnimation);
  } else {
    initHeroTextAnimation();
  }

  // Re-initialize when sections are dynamically loaded (for theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initHeroTextAnimation);
  }
})();

